import { axiosInstance, parseResponse, TENANT_API_URL } from "..";

const ZONES = `${TENANT_API_URL}/zones`;

export const getZonesAsync = () =>
  axiosInstance.get(`${ZONES}/list`, {
    // Zone membership changes independently of the roster page. Explicitly
    // bypass intermediary/browser caches so a newly-created zone is visible
    // without a hard refresh.
    headers: {
      "Cache-Control": "no-cache",
    },
  });

export const getZoneList = async () => {
  try {
    const response = await axiosInstance.get(`${ZONES}/list`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getAllZones = async () => {
  try {
    const response = await axiosInstance.get(`${ZONES}`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const fetchUnAllocatedUsers = async () => {
  try {
    const response = await axiosInstance.get(`${ZONES}/unallocated-users`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const createZone = async (data: any) => {
  try {
    const response = await axiosInstance.post(`${ZONES}`, data);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const updateZone = async (id: string, data: any) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const response = await axiosInstance.put(`${ZONES}/${id}`, data);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const deleteZone = async (id: string | undefined) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const response = await axiosInstance.delete(`${ZONES}/${id}`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
